import { render } from "./PageGerenciamentoProfissional.vue?vue&type=template&id=66092828&scoped=true"
import script from "./PageGerenciamentoProfissional.vue?vue&type=script&lang=js"
export * from "./PageGerenciamentoProfissional.vue?vue&type=script&lang=js"

import "./PageGerenciamentoProfissional.vue?vue&type=style&index=0&id=66092828&scoped=true&lang=css"

import exportComponent from "/builds/ssp/csmpmview/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66092828"]])

export default __exports__